import { FELLOWSHIP_CONTENT } from 'views/LandingPages/fellowshipContent';

// PM&R has no fellowship content entry — this matches --pmr-gradient
// in assets/css/pmr-landing.css so the deck pages sit alongside the
// main landing page without drifting.
const PMR_GRADIENT = 'linear-gradient(135deg, #172b4d 0%, #1a365d 50%, #2dce89 100%)';

/**
 * Background gradient for a specialty, reusing the same values the
 * fellowship landing pages theme themselves with.
 */
export const getSpecialtyGradient = (specialtyId) => {
  const entry = FELLOWSHIP_CONTENT[specialtyId];
  if (entry && entry.colors && entry.colors.gradient) return entry.colors.gradient;
  return PMR_GRADIENT;
};
